export const TOKEN_STORAGE_KEY = 'authToken';
export const socialMediaOptions = [
    {
        value: 'facebook',
        disabled: false,
    },
    {
        value: 'instagram',
        disabled: false,
    },
    {
        value: 'linkedin',
        disabled: false,
    },
    {
        value: 'twitter',
        disabled: false,
    },
    {
        value: 'threads',
        disabled: false,
    },
    {
        value: 'youtube',
        disabled: false,
    },
    {
        value: 'pinterest',
        disabled: false,
    },
    {
        value: 'tiktok',
        disabled: false,
    },
];
